// extracted by mini-css-extract-plugin
export default {"thumbnail":"simpleSkeletonItem_thumbnail__2-A2F","skeleton":"simpleSkeletonItem_skeleton__1Dqhi","skeleton-animation":"simpleSkeletonItem_skeleton-animation__pwkid"};